import { action } from "@storybook/addon-actions";
import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import Checkbox from "./Checkbox";

type Story = GenericStory<React.ComponentProps<typeof Checkbox>>;

const commonArgs: React.ComponentProps<typeof Checkbox> = {
    checked: false,
    indeterminate: false,
    onChange: action("onChange"),
    trackName: "Stories.Checkbox.TrackEvent",
    size: "sm",
    disabled: false
};

export default {
    title: "Form Components/Checkbox",
    component: Checkbox,
    args: commonArgs,
    argTypes: { size: { control: "radio", options: ["sm", "md"] } }
} as ComponentMeta<typeof Checkbox>;

const Template: Story = ({ checked: checkedProp, onChange, ...args }) => {
    const [checked, setChecked] = React.useState(checkedProp);

    React.useEffect(() => {
        setChecked(checkedProp);
    }, [checkedProp]);

    const handleChange = (value: boolean) => {
        setChecked(value);
        onChange?.(value);
    };

    return <Checkbox checked={checked} onChange={handleChange} {...args} />;
};

export const Default = Template.bind({});

export const WithLabel = Template.bind({});
WithLabel.args = {
    label: "Checkbox Label",
    helperText: "Checkbox helper text"
};

export const Medium = Template.bind({});
Medium.args = {
    label: "Checkbox Label",
    helperText: "Checkbox helper text",
    size: "md"
};

export const Disabled = Template.bind({});
Disabled.args = {
    disabled: true
};

export const DisabledChecked = Template.bind({});
DisabledChecked.args = {
    disabled: true,
    checked: true
};

export const Indeterminate = Template.bind({});
Indeterminate.args = {
    checked: true,
    indeterminate: true
};

export const IndeterminateDisabled = Template.bind({});
IndeterminateDisabled.args = {
    disabled: true,
    checked: true,
    indeterminate: true
};
